import { Details } from '../models/details.interfaces';

export const GoldMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'GOLD MEDALLION®',
    level: '0',
    name: 'gold'
  }
};

export const GoldMillionMilerMedallionBannerDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'GOLD MEDALLION®',
    level: '1',
    name: 'gold'
  }
};

export const GoldMedallionBannerWithLifetimeDetailsMocks: Details = {
  title: 'Good Morning, Rocky',
  action: {
    label: 'VIEW YOUR BENEFITS',
    url: '/us/en/skymiles/medallion-program/medallion-benefits'
  },
  milesData: {
    skyMiles: { title: 'SKYMILES #', subtitle: '8006270311' },
    miles: { title: 'MILES AVAILABLE', subtitle: '38,000' }
  },
  tier: {
    title: '2023 CURRENT STATUS: ',
    subtitle: 'GOLD MEDALLION®',
    level: '0',
    name: 'gold'
  }
};
